import { render, staticRenderFns } from "./games.vue?vue&type=template&id=c269085a&"
import script from "./games.vue?vue&type=script&lang=js&"
export * from "./games.vue?vue&type=script&lang=js&"
import style0 from "./games.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports